import { IconAlertWarning16 } from '@fabric-ds/icons/react';

type Props = {
    message: string;
};

export function ErrorMessage({ message }: Props) {
    const color = 'red';
    const icon = <IconAlertWarning16 viewBox="0 0 16 16" width={24} height={24} className="my-auto flex-shrink-0 text-red-600" />;
    return (
        <div
            className={`my-16 w-full rounded-16 border pl-24 border-${color}-500 bg-${color}-50 flex gap-16 text-left align-middle`}
            style={{ maxWidth: '680px' }}>
            {icon}
            <span className="my-24 flex-grow">{message}</span>
        </div>
    );
}
